import React from "react"
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import { Button } from "@novaescola/eva-react-v2";
import { sanitizeHtml } from "../../utils/sanitize";

export function VideoSection({ section, slug }) {
  const isLpFerramentaSondagem = slug.includes("sondagem-alfabetizacao")

  const YoutubeEmbed = ({ videoLink }) => (
    <div className="video-responsive">
      <iframe
        width="740"
        src={videoLink}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={`${section.body?.title} | Nova Escola `}
      />
    </div>
  );

  return (
    <section className="container-fluid eva-text-center container-blocks" style={{ backgroundColor: section.body?.backgroundColor, color: section.body?.textColor }}>
      <div className="row jc-center">
        <div className="col-sm-4 d-flex ai-center">
          <div className="eva-text-center">
            <Typography variant="title" size={4} asChild
              className="eva-margin-bottom-2"
            >
              <p>{section.body?.title}</p>
            </Typography>
            <Typography variant="body" size={1} asChild
              className="eva-margin-bottom-4 eva-color-cinza-600"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: section.body?.subtitle ? 
                    sanitizeHtml(section.body?.subtitle) 
                    : '',
                }}
              />
            </Typography>

            {
              isLpFerramentaSondagem ?
                <div className="eva-text-center" style={{ marginTop: '10px' }}>
                  <Button color="black" size="medium" fill="filled">
                    <a
                      href="https://novaescola.org.br/sala-do-professor/"
                      target="_self"
                      rel="noreferrer"
                      type="button"
                      className="eva-margin-center"
                      data-track={`SITE: Click - LP sala do professor - seção chamada - Botão do bloco video - COMECE AGORA`}
                    >
                      COMECE AGORA
                    </a>
                  </Button>
                </div>
                : null
            }

          </div>
        </div>
        <div className="col-sm-6">
          <YoutubeEmbed videoLink={section.body?.videoLink} />
        </div>
      </div>
    </section>
  )
}